import { ReactNode, useState } from 'react';
import classnames from 'classnames';

import style from './LeftTitle.module.scss';
import '@components/mixins/commonStyles.scss';

import { EntryTypeItemVisibilityButton } from '@components/ActionButtons/EntryTypeItemVisibilityButton';
import { DictationButtonSlotContext } from '@components/Dictation';

export enum LeftTitleModifiers {
    // @ts-ignore
    WithoutTopPadding = style.withoutTop,
}

export interface LeftTitleWithVisibilityButtonProps {
    title: string;
    light?: boolean;
    modifiers?: LeftTitleModifiers[];
    customTitleWidth?: number;
    customTitleTop?: number;
    children: ReactNode;
    hideItemOnPrint?: boolean;
    showHideOnPrintButton?: boolean;
    onChangeHideItemOnPrint?(hideFromPatient: boolean): void;
}

interface Props extends LeftTitleWithVisibilityButtonProps {}

export function LeftTitleWithVisibilityButton({
    title,
    light,
    customTitleWidth,
    customTitleTop,
    children,
    modifiers,
    hideItemOnPrint,
    showHideOnPrintButton,
    onChangeHideItemOnPrint,
}: Props) {
    const [slotNode, setSlotNode] = useState<HTMLElement | null>(null);

    return (
        <div
            className={classnames([
                style.root,
                'font_label',
                modifiers && [...modifiers],
                !!customTitleWidth && style.root_customTitleWidth,
                (light || !!customTitleWidth) && style.root_light,
            ])}
        >
            <div
                className={style.title}
                style={
                    !!customTitleWidth || !!customTitleTop
                        ? {
                              width: `${customTitleWidth}px`,
                              top: `${customTitleTop}px`,
                          }
                        : {}
                }
            >
                {title}
                <div
                    ref={setSlotNode}
                    style={{ display: 'contents' }}
                />
                {showHideOnPrintButton && (
                    <EntryTypeItemVisibilityButton
                        hideItemOnPrint={hideItemOnPrint}
                        onChangeVisibilityClick={onChangeHideItemOnPrint}
                    />
                )}
            </div>
            <DictationButtonSlotContext.Provider value={slotNode}>{children}</DictationButtonSlotContext.Provider>
        </div>
    );
}
